import { ref, computed } from 'vue'

export interface Advance {
  id?: number
  name: string
  status?: string
  description?: string
  doc?: object | null
  test?: object | null
  requires?: string[]
  required_by?: string[]
  due_date?: string | null

  [key: string]: string | number | object | string[] | null | undefined
}

export function useAdvances() {
  const advances = ref<Advance[]>([]) // items is now Ref<Item[]>
  const getItems = async (): Promise<Advance[]> => {
    const response = await fetch('/adv/')
    // Assert the response is OK
    if (!response.ok) {
      throw new Error('Failed to fetch Advances')
    }
    // Assert the response is JSON
    if (!response.headers.get('content-type')?.includes('application/json')) {
      throw new Error('Invalid content type')
    }

    return await response.json()
  }

  const fetchItems = async () => {
    advances.value = await getItems()
  }

  const advanceKeys = computed(() => {
    return advances.value.length > 0 ? Object.keys(advances.value[0]) : []
  })

  const getCookie = (name: string) => {
    let cookieValue = null
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';')
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim()
        if (cookie.substring(0, name.length + 1) === name + '=') {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
          break
        }
      }
    }

    if (cookieValue === null) {
      throw new Error('Cookie not found')
    }

    return cookieValue
  }

  // const data = { name: name.value, id: id.value, status: status.value };
  const createAdvance = async (data: Advance) => {
    const csrftoken = getCookie('csrftoken')
    if (csrftoken === null) {
      throw new Error('CSRF token not found')
    }
    const response = await fetch('/adv/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': csrftoken
      },
      body: JSON.stringify(data)
    })
    if (!response.ok) {
      throw new Error('Failed to create advance')
    }
    fetchItems()
  }

  return { advances, fetchItems, createAdvance, advanceKeys }
}
